import React from 'react';
import { CTAButton } from './CTAButton';
import { Shield, Star } from 'lucide-react';
export function FinalCTA() {
  return <section className="bg-navy text-white py-20 px-4 text-center border-t-8 border-patriot-red" data-id="element-165">
      <div className="max-w-3xl mx-auto" data-id="element-166">
        <p className="text-patriot-red font-bold uppercase tracking-widest text-sm mb-4" data-id="element-167">
          ⚡ Limited Collector Release
        </p>

        <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-168">
          Own The Story. Keep The Legacy.
        </h2>

        <p className="text-xl text-blue-200 mb-4 max-w-2xl mx-auto" data-id="element-169">
          This is the tribute-style bundle many patriots wish existed: the life,
          the turning points, the quotes, and the context—organized in one
          place.
        </p>

        <p className="text-lg text-blue-300 mb-10 max-w-2xl mx-auto" data-id="element-170">
          For less than a coffee run, download it instantly and share it with
          your family.
        </p>

        {/* Value stack */}
        <div className="bg-navy-light border border-blue-800 rounded-xl p-6 max-w-md mx-auto mb-8 text-left" data-id="element-171">
          <p className="text-gold font-bold text-center mb-4 uppercase tracking-wide text-sm" data-id="element-172">
            Everything Included Today
          </p>
          {[{
          label: 'The Main Archive: Voices of Freedom',
          value: '$47.97'
        }, {
          label: 'The Heritage Timeline: Remembering Charlie Kirk',
          value: '$23.98'
        }, {
          label: "The Patriot's Playbook: The Last Patriot",
          value: '$23.99'
        }].map((item, i) => <div key={i} className="flex justify-between items-center py-2 border-b border-blue-900 last:border-0" data-id="element-173">
              <span className="text-blue-200 text-sm font-bold" data-id="element-174">
                {item.label}
              </span>
              <span className="text-gold font-bold text-sm" data-id="element-175">{item.value}</span>
            </div>)}
          <div className="flex justify-between items-center pt-3 mt-1" data-id="element-176">
            <span className="text-white font-bold" data-id="element-177">Your Price Today</span>
            <span className="text-gold font-bold text-xl" data-id="element-178">$17</span>
          </div>
        </div>

        <div className="max-w-md mx-auto mb-4" data-id="element-179">
          <CTAButton data-id="element-180">YES — DOWNLOAD THE COLLECTOR BUNDLE FOR $17 →</CTAButton>
        </div>

        <p className="text-blue-300 text-sm mb-6" data-id="element-181">
          Read it tonight. Listen tomorrow morning. Share it this weekend.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 text-gray-400 text-xs" data-id="element-182">
          <div className="flex items-center gap-1" data-id="element-183">
            <Shield size={14} data-id="element-184" />
            <span data-id="element-185">Secure Checkout</span>
          </div>
          <span data-id="element-186">·</span>
          <div className="flex items-center gap-1" data-id="element-187">
            <span data-id="element-188">⚡</span>
            <span data-id="element-189">Instant Digital Delivery</span>
          </div>
          <span data-id="element-190">·</span>
          <div className="flex items-center gap-1" data-id="element-191">
            <span data-id="element-192">💯</span>
            <span data-id="element-193">100% Satisfaction Guarantee</span>
          </div>
          <span data-id="element-194">·</span>
          <div className="flex items-center gap-1" data-id="element-195">
            <div className="flex" data-id="element-196">
              {[...Array(5)].map((_, i) => <Star key={i} size={10} fill="currentColor" className="text-gold" data-id="element-197" />)}
            </div>
            <span data-id="element-198">12,000+ Patriots</span>
          </div>
        </div>
      </div>
    </section>;
}